import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Modal,
} from "@mui/material";

export default function ShowInfo() {
	return (
		<Modal
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
			open={true}
		>
			<Card
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<CardHeader title={process.env.REACT_APP_NAME} />
				<CardContent>Version: {process.env.REACT_APP_VERSION}</CardContent>
				<CardActions>
					<Button
						onClick={() => {
							const event = new Event("showInfo");
							window.dispatchEvent(event);
						}}
					>
						OK
					</Button>
				</CardActions>
			</Card>
		</Modal>
	);
}
